import { REVIEWSCHEDULER } from "../../../utils/Constants";

const defaultGlobalDashboardFilter = {
    agency_id: '',
    all_agency: true,
    datemodified: {
        start_date: undefined,
        end_date: undefined
    },
    page: 1,
    field: 'updated_on',
    direction: 'desc',
    userType: REVIEWSCHEDULER,
    isDateRangeClicked: "",
    selectedCarriers: [],
    selectedAgencyState: ["true"],
    selectedAgencies: [],
    filteredAgencyIds: []
};

export const createGlobalDashboardFilter = (set, get) => ({
    GlobalDashboardFilter: defaultGlobalDashboardFilter,

    setGlobalDashboardFilter: (newFilter) =>
        set((state) => ({
            GlobalDashboardFilter: {
                ...state.GlobalDashboardFilter,
                ...newFilter,
                datemodified: {
                    ...state.GlobalDashboardFilter.datemodified,
                    ...newFilter.datemodified,
                }
            },
        })),

    resetGlobalDashboardFilter: () =>
        set(() => ({
            GlobalDashboardFilter: defaultGlobalDashboardFilter,
        })),
});



// WEBPACK FOOTER //
// ./src/store/slices/GlobalDashboardSlice/GlobalDashboardSlice.js